import cx from 'classnames';

import { Direction } from 'apps/web/src/lib/types';

interface Props {
  direction: Direction;
  onclick: (direction: Direction) => void;
  disabled: boolean;
}

function Button(props: Props) {
  return (
    <>
      <button
        onClick={() => props.onclick(props.direction)}
        disabled={props.disabled}
        className={cx(
          'h-16 w-16 shadow-xl opacity-100 rounded-full bg-white flex justify-center items-center transition-all',
          props.disabled && '!opacity-50',
        )}
      >
        <img
          src="/arrow.svg"
          className={cx(props.direction === Direction.left && 'rotate-180')}
          alt={`scroll ${props.direction}`}
        />
      </button>
    </>
  );
}

export default Button;
